<template>
  <div class="c-textarea">
    <textarea-len
      v-model="textarea"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      :max="max"
      :rows="rows"
      :overflow="overflow"
    />
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
import TextareaLen from '@/components/input/textarea-len.vue'
export default {
  name: 'rowTextarea',
  components: { TextareaLen },
  props: {
    value: {
      type: String
    },
    name: {
      type: String
    },
    readonly: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    max: {
      type: Number
    },
    verify: {
      type: Boolean
    },
    rows: {
      type: Number
    },
    overflow: {
      type: Boolean
    },
    pattern: {
      type: String
    }
  },
  computed: {
    textarea: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    msg() {
      let err = ''
      const reg = new RegExp(this.pattern, 'g')
      if (this.verify && isEmpty(this.textarea)) err = `${this.name}不能为空`
      else if (this.verify && this.pattern && reg.test(this.textarea)) err = `${this.name}不符合规则`
      return err
    }
  }
}
</script>
<style lang="scss" scoped>
.c-textarea {
  width: 100%;

  .c-col-msg {
    position: absolute;
    z-index: 997;
    bottom: -23px;
    color: #ff4400;
  }
}
</style>
